import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './bundle-update-create.html';
import { OrderType, ProductStatus } from '@nuskin/ns-shop';
import { ProductDataService } from '@nuskin/ns-product'
import { MySiteRestService } from '@nuskin/my-site-api';
import { MySiteApp, PREDICTIVE_SEARCH_LIMIT, TOASTER_ACTIONS } from '../../my-site-app';
import { nuskin, equinoxLocalStorage } from '@nuskin/ns-util';
import { getConfiguration, getCachedConfiguration } from "@nuskin/configuration-sdk";

import { ProductBundles } from '@nuskin/my-site/src/my-site-app/forms/product-bundles/product-bundles';
/**
 * @customElement
 * @polymer
 */
export class BundleUpdateCreate extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);

        this.data = {} //api data

        this.products = [];

        this.translations = {
            header: '',
            name: this.content.bundlesFormBundleName,
            about: this.content.bundlesFormAboutBundle,
            desc: this.content.bundlesFormUpTo
        }

        this.eventsToListenTo = [
            'value-changed',
            'valid-changed',
            'invalid-changed'
        ];

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();

        this.bundleNameLength = 0;
        this.aboutBundleLength = 0;
        this.maxCharTitle = 50;
        this.maxCharAbout = 500;
        
        // const equinoxMarketConfig = getConfiguration(["Equinox_Markets"]).Equinox_Markets 
        // this.maxProducts = parseInt(equinoxMarketConfig.MySite_bundle_maxProducts) || 12; 
        this.maxProducts = 12
        this.productsLeft = this.maxProducts;

        this.nsSearchTranslations = {
            desktopPlaceholder: this.content.yourProductsFormSearchPlaceholder,
            mobilePlaceholder: this.content.yourProductsFormSearchPlaceholder,
            noResults: this.content.yourProductsFormSearchNoResults
        }
    }

    ready() {
        super.ready();
        this.getFormFields();
        this.formFields.forEach(field => {
            this.eventsToListenTo.forEach(event => {
                field.addEventListener(event, this.parentNode.formChanged);
                field.addEventListener('focused-changed', this.parentNode.formTouched);
            });
        });
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'bundle-update-create';
    }

    connectedCallback() {
        super.connectedCallback();
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this.getMySiteData.bind(this));
        this.mySite.addEventListener('on-menu-item-click', this._handleFormShow.bind(this));
        this.mySite.addEventListener('common-strings-changed', this._subscribeToCommonStrings.bind(this));

        this.$.sortable.$.itemList.addEventListener('rendered-item-count-changed', this._handleListChange.bind(this));
        this.$.sortable.addEventListener('on-ns-sorted-list-reorder', this._handleOrderChange.bind(this));
        this.$.sortable.addEventListener('on-ns-sorted-item-removed', this._handleItemRemoved.bind(this));
        this.$.bundleName.addEventListener('value-changed', this._handlebundleNameChange.bind(this));
        this.$.aboutBundle.addEventListener('value-changed', this._handleaboutBundleChange.bind(this));
        this.$.productSearch.addEventListener('on-ns-searchbar-predictive-search-result', this._handlePredictiveSearch.bind(this));
        this.mySite.addEventListener('current-market-changed', e => {
            this.currentMarket = e.detail.value
            this.setPredictiveSearch();
        })
        this.mySite.addEventListener('current-language-changed', e => {
            this.currentLanaguage = e.detail.value
            this.setPredictiveSearch();
        })
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        this.mySite.removeEventListener('my-site-data-changed', this.getMySiteData.bind(this));
        this.mySite.removeEventListener('on-menu-item-click', this._handleFormShow.bind(this));

        this.$.sortable.$.itemList.removeEventListener('rendered-item-count-changed', this._handleListChange.bind(this));
        this.$.sortable.removeEventListener('on-ns-sorted-list-reorder', this._handleOrderChange.bind(this));
        this.$.sortable.removeEventListener('on-ns-sorted-item-removed', this._handleItemRemoved.bind(this));
        this.$.bundleName.removeEventListener('value-changed', this._handlebundleNameChange.bind(this));
        this.$.aboutBundle.removeEventListener('value-changed', this._handleaboutBundleChange.bind(this));
        this.$.productSearch.removeEventListener('on-ns-searchbar-predictive-search-result', this._handlePredictiveSearch.bind(this));
        this.mySite.removeEventListener('current-market-changed', e => {
            this.currentMarket = e.detail.value;
        })
        this.mySite.removeEventListener('current-language-changed', e => {
            this.currentLanaguage = e.detail.value;
        })
    }

    setPredictiveSearch() {
        this.set('searchOptions', {
            market: this.currentMarket,
            language: this.currentLanaguage,
            orderTypes: [OrderType.ORDER],
            predictiveLimit: PREDICTIVE_SEARCH_LIMIT
        });
    }

    _handleOrderChange(e) {
        this.set('products', e.detail.reorderedList);

        let bundles = this.getUpdatedData(true);
        this.parentElement.updateAndNotify(bundles, true, false, 'bundles', true);

        this.parentElement.formTouched();
    }

    _handleItemRemoved(e) {
        let updatedList = this.products.slice();
        updatedList.splice(e.detail.index * 1, 1);
        this.set('products', updatedList);

        let bundles = this.getUpdatedData(true);
        this.parentElement.updateAndNotify(bundles, true, false, 'bundles', true);

        this.parentElement.formTouched();
        this.parentElement.formChanged();
    }

    _handleFormShow(e) {
        if (e.detail.item === BundleUpdateCreate.is) {
            this.set('searchedProducts', [])

            this.set('bundleId', e.detail.additionalData.bundleId * 1);
            this.set('action', e.detail.additionalData.do);
            // reset products to [] if creating new bundle
            if (this.action === 'create') {
                this.set('products', []);
            }

            this.set('translations.title', this.action === 'edit' ? this.content.bundlesFormEditBundle : this.content.bundlesFormNewBundle);

            this.parentElement.setCustomBackLocation(ProductBundles.is);
            this.$.sortable.resizeItemsContainer();
        }
    }

    handleEmptyBundleContainer(remove) {
        let bundles;
        let bundlesInfo;

        if (remove) {
            bundlesInfo = this.getBundlesInfo();
            let match = this.getBundles().find(item => item.temp);
            if (match)
                bundlesInfo = bundlesInfo.filter(item => item.bundle_id !== match.id);
        } else {
            bundles = this.getUpdatedData(true);
            bundlesInfo = this.getUpdatedData(false, true);
        }

        this.parentElement.updateAndNotify(bundlesInfo, true, true, 'bundlesInfo');
        this.parentElement.updateAndNotify(bundles, true, false, 'bundles');
    }

    _handlebundleNameChange(e) {
        this.bundleNameLength = e.target.value.length;

        let bundlesInfo = this.getUpdatedData(false, true);
        this.parentElement.updateAndNotify(bundlesInfo, true, true, 'bundlesInfo', true);
    }

    _handleaboutBundleChange(e) {
        this.aboutBundleLength = e.target.value.length;

        let bundlesInfo = this.getUpdatedData(false, true);
        this.parentElement.updateAndNotify(bundlesInfo, true, true, 'bundlesInfo', true);
    }

    async getMySiteData() {

        if (this.mySite.currentForm !== BundleUpdateCreate.is) return;
        this.set('data', this.mySite.mySiteData);

        if (this.bundleId === undefined) return;

        let skus = this.getBundleProductsSkus();

        let products = [];

        // add empty container
        if (this.action === 'create')
            this.handleEmptyBundleContainer();

        // remove empty container if user didn't save it
        if (this.mySite.currentForm === ProductBundles.is) {
            this.action = ''; // reset action to nothing. Important! Otherwise endless loop...
            this.handleEmptyBundleContainer(true);
        }

        try {
            for (let i = 0; i < skus.length; i++) {
                let sku = skus[i]
                const prodSvc = await ProductDataService.getProductData(sku);

                if (prodSvc.products && prodSvc.products.length) {
                    const productToAdd = prodSvc.products[0]
                    if (productToAdd.isBase()) {
                        productToAdd.variants[sku] ? products.push({
                            sku: productToAdd.variants[sku].sku,
                            itemName: productToAdd.variants[sku].title,
                            priceMap: productToAdd.variants[sku].priceMap,
                            psv: productToAdd.variants[sku].pv,
                            img: (productToAdd.variants[sku].thumbnail.includes('https')) ? productToAdd.variants[sku].thumbnail : nuskin.configuration.siteUrl + productToAdd.variants[sku].thumbnail
                        }) :  this.mySite.dispatchEvent(new CustomEvent('my-site-toaster', {
                            detail: {
                                theme: 'warning',
                                icon: 'warning',
                                message: TOASTER_ACTIONS.noBaseSku
                            }
                        }));
                    } else {
                        products.push({
                            sku: sku,
                            itemName: productToAdd.title || 'Product not found',
                            priceMap: productToAdd.priceMap || {
                                "WRTL": 0,
                                "WADW-WRTL": 0,
                                "WADR": 0,
                                "RTL": 0,
                                "WWHL": 0,
                                "WADW": 0,
                                "WHL": 0
                            },
                            psv: productToAdd.pv || 0,
                            img: (productToAdd.thumbnail && productToAdd.thumbnail.includes('https')) ? productToAdd.thumbnail : productToAdd.thumbnail ? nuskin.configuration.siteUrl + productToAdd.thumbnail : ''
                        })
                    }
                }
            }

        } catch (error) {
            console.log({ 'context': 'BundleUpdateCreate.getMySiteData', 'error': error });
        }

        this.set('products', products);
        this.parentNode.formChanged();
    }

    getBundleProductsSkus() {
        if (this.data.storefront) {
            let bundles = this.getBundles();
            let bundle = bundles.length ? bundles.find(item => item.id === this.bundleId) || {} : {};
            let bundlesInfo = this.getBundlesInfo();
            let bundleInfo = bundlesInfo.find(item => {
                return item ? item.bundle_id === this.bundleId : {}
            }) || {};

            this.set('bundleName', bundleInfo.name);
            this.bundleNameLength = (bundleInfo.name && bundleInfo.name.length) ? bundleInfo.name.length : 0;
            this.set('aboutBundle', bundleInfo.about);
            this.aboutBundleLength = (bundleInfo.about && bundleInfo.about.length) ? bundleInfo.about.length : 0;

            return bundle.skus || [];
        }
    }

    getBundles() {
        if (this.data.storefront) {
            let subdomain = Object.keys(this.data.storefront)[0];

            return subdomain && this.mySite.currentMarket
                ? this.data.storefront[subdomain][this.mySite.currentMarket].bundles || []
                : [];
        }
    }

    getBundlesInfo() {
        if (this.data.storefront) {
            let subdomain = Object.keys(this.data.storefront)[0];

            return subdomain && this.mySite.currentMarket
                ? this.data.storefront[subdomain][this.mySite.currentMarket].lang[this.mySite.currentLanguage].bundlesInfo || []
                : [];
        }
    }

    _subscribeToCommonStrings(e) {
        let data = e.detail.value
        this.set('fieldRequired', data.fieldRequired)
    }

    async _handlePredictiveSearch(e) {
        let res = e.detail;
        const equinoxMarketConfig = (await getConfiguration(["Equinox_Markets"]))
            .Equinox_Markets;
        const isEquinoxEnabled = equinoxLocalStorage.isEquinoxEnabled() && equinoxMarketConfig.active;
        let products = res;

        //filter bundle product search typehead
        //increased latency due to results filtering if market is equinox enabled
        if (isEquinoxEnabled && (res && res.length)) {

            products = await Promise.all(
                res.map(async (item) => {
                    try {
                        const productData = await ProductDataService.getProductData(item.sku);

                        return {
                            ...item,
                            status: (productData.products && productData.products.length > 0 && productData.products[0].status) ? productData.products[0].status : ProductStatus.NOT_RELEASED_FOR_SALE
                        };

                    } catch (e) {
                        console.log(e);
                    }

                    return { ...item, status: ProductStatus.NOT_RELEASED_FOR_SALE };
                })
            );

            products = products.filter(product => {
                return product.status === ProductStatus.ReleasedForSale;
            });
        }


        this.searchedProducts = products && products.length ? products : [{}]; // empty object is added to indicate 'No Results'
    }

    async _onSlottedSelect(e) {
        let item = JSON.parse(e.currentTarget.dataset.item);
        const equinoxMarketConfig = getCachedConfiguration("Equinox_Markets")
        const isEquinoxEnabled = equinoxMarketConfig.active;

        this.$.productSearch.blur();

        if (this.products.find(prod => item.sku === prod.sku)) return;
        let prodSvc;
        try {
            prodSvc = await ProductDataService.getProductData(item.sku);
        } catch (err) { console.log(err) }
        let products = this.products.slice();
        if (this.maxProducts <= products.length) return;


        if (isEquinoxEnabled) {
            const productsSvc = prodSvc.products
                .map((product) => ({
                    sku: product.sku,
                    itemName: product.title,
                    priceMap: product.priceMap,
                    psv: product.pv,
                    img: (product.thumbnail.includes('https')) ? product.thumbnail : nuskin.configuration.siteUrl + product.thumbnail
                }));

            products.push(productsSvc[0]);
            products.flat();
        } else {
            const productToAdd = prodSvc.products[0]
            if (productToAdd.isBase() && productToAdd.sku === item.sku) {
                products.push({
                    sku: productToAdd.sku,
                    itemName: productToAdd.title,
                    priceMap: productToAdd.priceMap,
                    psv: productToAdd.pv,
                    img: (productToAdd.thumbnail.includes('https')) ? productToAdd.thumbnail : nuskin.configuration.siteUrl + productToAdd.thumbnail
                });

            } else if (productToAdd.isBase() && productToAdd.sku !== item.sku) {
                products.push({
                    sku: productToAdd.variants[item.sku].sku,
                    itemName: productToAdd.variants[item.sku].title,
                    priceMap: productToAdd.variants[item.sku].priceMap,
                    psv: productToAdd.variants[item.sku].pv,
                    img: (productToAdd.variants[item.sku].thumbnail.includes('https')) ? productToAdd.variants[item.sku].thumbnail : nuskin.configuration.siteUrl + productToAdd.variants[item.sku].thumbnail
                });
            } else {
                productToAdd.sku !== '' ? products.push({
                    sku: productToAdd.sku,
                    itemName: productToAdd.title,
                    priceMap: productToAdd.priceMap,
                    psv: productToAdd.pv,
                    img: (productToAdd.thumbnail.includes('https')) ? productToAdd.thumbnail : nuskin.configuration.siteUrl + productToAdd.thumbnail
                }) : this.mySite.dispatchEvent(new CustomEvent('my-site-toaster', {
                    detail: {
                        theme: 'warning',
                        icon: 'warning',
                        message: TOASTER_ACTIONS.noBaseSku
                    }
                }));
            }
        }
        this.set('products', products);

        let bundles = this.getUpdatedData(true);

        this.parentElement.updateAndNotify(bundles, true, false, 'bundles', true);

        this.parentElement.formTouched();
        this.parentElement.setFormValidity(true);
    }

    _handleListChange() {
        this.productsLeft = this.maxProducts - this.products.length;
    }

    isEmptyIndicator(item) {
        return Object.keys(item).length === 0;
    }

    getUpdatedData(getBundles, getInfo) {
        let bundlesInfo;
        let bundles;

        if (getBundles) {
            bundles = this.getBundles();
            let index = bundles.findIndex(item => item.id === this.bundleId);

            if (index < 0) // creating new bundle
                bundles[bundles.length] = {
                    id: this.bundleId,
                    skus: this.products.map(item => item.sku),
                    temp: true
                };
            else // editing existing
                bundles[index].skus = this.products.map(item => {
                    return item.sku
                });
            return bundles;
        }
        if (getInfo) {
            bundlesInfo = this.getBundlesInfo();
            let infoIndex = bundlesInfo.findIndex(item => item.bundle_id === this.bundleId);
            infoIndex = infoIndex < 0 ? bundlesInfo.length : infoIndex;
            // DTS-266
            bundlesInfo[infoIndex] = {
                name: this.$.bundleName.focused
                    ? this.bundleName
                    : (this.bundleName || this.translations.title),
                about: this.aboutBundle || '',
                bundle_id: this.bundleId
            }

            return bundlesInfo
        }
    }

    save() {
        let that = this;
        return function () {
            let bundles = that.getUpdatedData(true);
            let bundlesInfo = that.getUpdatedData(false, true);

            bundles = bundles.filter(bundle => bundle.id !== undefined && bundle.skus)

            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: BundleUpdateCreate.is,
                        bundles,
                        bundlesInfo,
                        action: that.action
                    }
                });
            } catch (err) { console.log(err) }

            return MySiteRestService.saveBundles(bundles, bundlesInfo, that.mySite.currentMarket, that.mySite.currentLanguage, false);
        }
    }

    getFormFields() {
        this.formFields = [
            this.$.aboutBundle,
            this.$.bundleName,
            this.$.sortable
        ];
    }

}

window.customElements.define(BundleUpdateCreate.is, BundleUpdateCreate);
